import { Breadcrumbs, CrumbProps } from "@amzn/stencil-react-components/breadcrumbs";
import { ButtonVariant } from "@amzn/stencil-react-components/button";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { Button } from "@amzn/uxm-stencil-react-components/lib/src/stencil/button";
import FeatureList from "common/components/FeatureList/FeatureList";
import { PageMainContainer } from "common/components/PageMainContainer/PageMainContainer";
import { Paths } from "common/paths/paths";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";
import { useHistory } from "react-router-dom";

export const WhatsNew: FC = () => {
  const history = useHistory();

  return (
    <>
      <div className="aiforme-gradient-back">
        <PageMainContainer>
          <Row>
            <Breadcrumbs
              crumbs={[
                {
                  title: getString("logoText"),
                  url: "/",
                },
                {
                  title: getString("aiForMe.title"),
                  url: Paths.aiforme.url,
                },
                {
                  title: getString("aiForMe.whatsNew.title"),
                  url: Paths.whatsNew.url,
                },
              ]}
              onCrumbClick={
                /* istanbul ignore next */
                (e, crumb: CrumbProps) => {
                  if (crumb.url) {
                    e.preventDefault();
                    history.push(crumb.url);
                  }
                }
              }
            />
          </Row>
          <Row justifyContent="space-between" alignItems="flex-end" style={{ minHeight: "270px" }}>
            <Col flex={2}>
              <Text data-cy="welcome-title" fontSize={"T500"} fontWeight="bold" style={{ paddingBottom: 20 }}>
                {getString("aiForMe.whatsNew.title")}
              </Text>
              <Text style={{ paddingBottom: 20 }}>{getString("aiForMe.whatsNew.message")}</Text>

              <Row columnGap={20} padding={{ bottom: 45 }}>
                <Button
                  variant={ButtonVariant.Primary}
                  onClick={
                    /* istanbul ignore next */
                    () => {
                      history.push(Paths.aiforme.url);
                    }
                  }
                  touchpoint="go-back-home"
                >
                  {getString("aiForMe.aiTools")}
                </Button>
              </Row>
            </Col>
            <Col flex={1}>
              <img
                src="/img/aiforme-people-animated.svg"
                alt="Two people working using AI tools"
                style={{
                  maxWidth: 468,
                  width: "100%",
                  height: "auto",
                }}
                data-testid="people-img"
              />
            </Col>
          </Row>
        </PageMainContainer>
      </div>
      <PageMainContainer>
        <FeatureList />
      </PageMainContainer>
    </>
  );
};
